import { PageTitle } from "Components/Titles";
import { Container } from "semantic-ui-react";
import { UpdateAccount } from "Features/Account";
import { useTranslation } from "react-i18next";

function EditAccount () {

    const { t } = useTranslation();

    return (
        <Container className="page">
            <PageTitle title={t("pages.editAccount")} />
            <UpdateAccount />
        </Container>
    );
}

export default EditAccount;